import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  api_url = environment.url;

  constructor(private http: HttpClient) { }

  getFiscalRegimes() {
    return this.http.get(`${this.api_url}client/fiscal-regimes`)
  }

  getCfdiUses() {
    return this.http.get(`${this.api_url}client/cfdi-uses`)
  }

  addClient(data: any) {
    return this.http.post(`${this.api_url}client/add`, data);
  }

  updateClient(data: any, id: number) {
    return this.http.post(`${this.api_url}client/update/${id}`, data);
  }

  listClient() {
    return this.http.get(`${this.api_url}client/list`)
  }
  getId(id: number) {
    return this.http.get(`${this.api_url}client/show/${id}`)
  }

  getPostal(code: any) {
    return this.http.get(`${this.api_url}code_postal/${code}`)
  }

  getInfo() {
    return this.http.get(`${this.api_url}client/getCombo`)
  }
  deleteClient(id: any) {
    return this.http.get(`${this.api_url}client/delete/${id}`)
  }

  importClients(file: File, delimiter?: string, dryRun?: boolean): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('file', file);
    if (delimiter) {
      formData.append('delimiter', delimiter);
    }
    if (dryRun !== undefined && dryRun !== null) {
      formData.append('dry_run', dryRun ? '1' : '0');
    }

    return this.http.post<any>(`${this.api_url}client/import`, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  exportClients() {
    return this.http.get(`${this.api_url}client/export`, {
      responseType: 'blob'
    })
  }
}
